import { useEffect } from 'react';
import { RouterProvider } from 'react-router';
import { registerTokenGetter } from '@shared/api/client';
import { getStoredToken, restoreSession } from '@features/auth';
import { AppProviders } from './providers/AppProviders';
import { store } from './store/store';
import { router } from './router/router';

// Le client API puise le token JWT via la feature auth (évite un cycle d'import).
registerTokenGetter(getStoredToken);

/**
 * Racine de composition de l'application :
 * providers transverses + routeur agrégeant les routes des features.
 * Restaure la session (token persisté) au démarrage.
 */
export function App() {
  useEffect(() => {
    void store.dispatch(restoreSession());
  }, []);

  return (
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  );
}
